import { apiSlice } from "../apiSlice";
// export const Activesizelist = createAsyncThunk('/activesizelist', async () => {
//   const response = await ApiHelperFunction({
//     urlPath: 'size/active/size',
//     method: 'GET',
//   });
//   return response;
// });
export const returnPolicySlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        returnPolicylist: builder.query({
            query: (data) => ({
                url: 'returnPolicy',
                method: 'GET',
                credentials: "include",
            }),
            providesTags: ['returnPolicy']

        }),
        Create_Update_returnPolicy: builder.mutation({
            query: (data) => ({
                url: 'returnPolicy',
                method: 'POST',
                body: data,
                credentials: "include",
            }),
            invalidatesTags: ['returnPolicy']

        }),

    }),
});

export const {
    useCreate_Update_returnPolicyMutation,
    useReturnPolicylistQuery
} = returnPolicySlice;

